import { app } from '../../../app';
import { Controller } from './logout.controller';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.logout', {
        url: '/logout',
        template: '',
        controller: Controller,
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/logout/logout.state.js